"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPERTY_TYPES = void 0;
exports.PROPERTY_TYPES = {
    hy: {
        sell: {
            house: 'sepakan-tun-',
            apartment: 'bnakaran-',
            commercial: 'komercion-tarack-',
        },
        rent: {
            house: 'arandznatun-',
            apartment: 'bnakaran-',
            commercial: 'grasenyakayin-taracq-',
        },
    },
    ru: {
        sell: {
            house: 'chastniy-dom-',
            apartment: 'kvartira-',
            commercial: 'kommercheskaya-',
        },
        rent: {
            house: 'chastniy-dom-',
            apartment: 'kvartira-',
            commercial: 'kommercheskaya-',
        },
    },
    en: {
        sell: {
            house: 'house-',
            apartment: 'apartments-',
            commercial: 'commercial-',
        },
        rent: {
            house: 'house-',
            apartment: 'apartments-',
            commercial: 'commercial-',
        },
    },
};
